import { getEunpyeongPostAuthPath } from './eunpyeongCare';

const POST_AUTH_LANDING_REDIRECT_KEY = 'landing.post-auth.redirect';

const getPostAuthStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.sessionStorage;
};

export const setPostAuthLandingRedirect = (path: string) => {
  if (!path || !path.startsWith('/')) {
    return;
  }

  getPostAuthStorage()?.setItem(POST_AUTH_LANDING_REDIRECT_KEY, path);
};

export const consumePostAuthLandingRedirect = () => {
  const storage = getPostAuthStorage();
  if (!storage) {
    return null;
  }

  const redirectPath = storage.getItem(POST_AUTH_LANDING_REDIRECT_KEY);
  storage.removeItem(POST_AUTH_LANDING_REDIRECT_KEY);

  if (typeof redirectPath === 'string' && redirectPath.startsWith('/')) {
    return redirectPath;
  }

  return null;
};

export const clearPostAuthLandingRedirect = () => {
  getPostAuthStorage()?.removeItem(POST_AUTH_LANDING_REDIRECT_KEY);
};

/** 은평구 쿠폰 플로우가 있으면 홈/랜딩보다 우선 */
export const resolvePostAuthRedirect = (fallback = '/app/home') => {
  const eunpyeongPath = getEunpyeongPostAuthPath();
  const landingPath = consumePostAuthLandingRedirect();
  return eunpyeongPath ?? landingPath ?? fallback;
};
